const child = {
  _id: 'child-001',
  caseId: 'KS-2025-0001',
  firstName: 'Maya',
  lastName: 'Johnson',
  dob: '2012-05-17',
  tags: ['priority-placement', 'siblings'],
  createdAt: '2024-12-01T15:05:00.000Z',
  updatedAt: '2025-01-04T18:22:00.000Z'
};

export default child;
